export default __webpack_public_path__ + "static/media/cardBackgroud.42c8e2b4.svg";